// ─── LEITURA COMPLETA DE UMA TABELA — fonte única de verdade ────────────────
//
// O Supabase devolve NO MÁXIMO 1000 linhas por pedido. Não dá erro, não dá
// aviso: pedes a tabela toda e recebes um pedaço dela. O código a seguir
// trabalha sobre esse pedaço convencido de que tem tudo.
//
// Já mordeu quatro vezes neste projecto — Catálogo, sync-naypes, sync-qogita e
// Financeiro. Desde a Naypes a tabela Produtos passou das 2.700 linhas, por
// isso qualquer leitura sem paginação está a perder mais de metade do
// catálogo. No Resumo Financeiro isso aparecia como "91 produtos sem custo
// registado": o custo existia, a linha é que nunca chegou.
//
// A ORDEM É OBRIGATÓRIA, e é por isso que é um argumento e não uma opção.
// Sem ORDER BY o Postgres não garante a mesma ordem entre pedidos: o bloco 2
// pode repetir linhas do bloco 1 e saltar outras — e o resultado fica errado
// de uma maneira que não se vê. Escolher sempre uma coluna ÚNICA (id, ou a
// chave primária), nunca uma com repetidos.
//
// Usar em vez de `supabase.from(...).select(...)` sempre que a leitura não
// esteja limitada por um `.in()`, `.eq()` ou `.limit()` que garanta poucas
// linhas. Devolve { data, error } — a mesma forma do cliente, para entrar
// directamente num Promise.all já existente.
//
//   lerTudo(() => supabase.from('Produtos').select('id, Nome'), 'id')
//
// O primeiro argumento é uma FUNÇÃO que constrói a query, não a query: cada
// bloco precisa de uma nova, porque um query builder do Supabase só se pode
// executar uma vez.

const BLOCO = 1000

// Travão de segurança: 200 blocos são 200 mil linhas. Se alguma vez for
// atingido é porque a query não está a filtrar nada, e é melhor devolver o que
// há do que ficar a pedir para sempre.
const MAX_BLOCOS = 200

export async function lerTudo(construirQuery, ordem, opcoes = {}) {
  const { ascending = true } = opcoes
  const linhas = []

  for (let bloco = 0; bloco < MAX_BLOCOS; bloco++) {
    const de = bloco * BLOCO
    const { data, error } = await construirQuery()
      .order(ordem, { ascending })
      .range(de, de + BLOCO - 1)

    // Devolve o erro com o que já se tinha lido: quem chama decide se mostra
    // o erro ou se trabalha com o parcial, como fazia antes.
    if (error) return { data: linhas, error }

    if (data && data.length) linhas.push(...data)
    if (!data || data.length < BLOCO) return { data: linhas, error: null }
  }

  return { data: linhas, error: null }
}
